module.exports = __webpack_public_path__ + "resources/flags-f836dbe0983fcd19282df377f34ba636.svg";